import { render, staticRenderFns } from "./ProgrammeEditModal.vue?vue&type=template&id=53422200&scoped=true&"
import script from "./ProgrammeEditModal.vue?vue&type=script&lang=js&"
export * from "./ProgrammeEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeEditModal.vue?vue&type=style&index=0&id=53422200&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53422200",
  null
  
)

export default component.exports